<template>
  <div class="vd-gl-content">
    <div>
      <a-icon type="info-circle" style="color: #40a9ff" />
      配置自定义规则
      <span v-if="form.id" style="color:red">
        修改活动: {{ form.id }} {{ form.name }}
      </span>
    </div>

    <br />

    <br />
    <div class="steps-content">
      <!-- 步骤一 -->
      <a-form-model
        ref="refForm"
        :model="form"
        :rules="rule"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="名称" prop="name">
          <a-input
            class="vd-input-s"
            v-model="form.name"
            placeholder="小程序名称"
          />
        </a-form-model-item>
        <a-form-model-item label="项目" prop="category">
          <a-select
            style="width: 108px"
            v-model="form.category"
            placeholder="项目类型"
          >
            <a-select-option
              v-for="item in categoryType"
              :key="item.id"
              :value="item.id"
              >{{ item.nickname }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="关联数据表" prop="table_id">
          <a-select
            style="width: 108px"
            v-model="form.table_id"
            @search="dataChange"
            show-search
            placeholder="数据表"
            :show-arrow="false"
            :filter-option="false"
          >
            <a-select-option
              v-for="item in dataList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="头图" prop="head_pic" required>
          <div style="display: flex;align-items:flex-end;">
            <div
              style="width: 345px;height: 100px;border: 1px solid #999999;margin-right: 20px;"
            >
              <div style="overflow: hidden;height: 100%;">
                <div style="position:relative;height: 100%;width: 345px">
                  <img
                    style="position: absolute;"
                    :src="form.head_pic"
                    width="345"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div>
              <a-button type="link" @click="useDefaultFace('head')">
                使用默认图片
              </a-button>
              <a-upload
                accept=".png,.jpg,.jpeg"
                :action="upload_url"
                @change="uploadChange"
                :data="{ remark: '自定义小程序头图' }"
                :show-upload-list="false"
                :beforeUpload="beforeHeadUpload"
              >
                <div>
                  <a-button icon="cloud-upload"> 重新上传</a-button>
                  <span class="common-mute">
                    请上传 宽690px高200px，并且小于1MB的图片</span
                  >
                </div>
              </a-upload>
            </div>
          </div>
        </a-form-model-item>

        <a-form-model-item label="查询界面图" prop="background_pic" required>
          <div style="display: flex;align-items:flex-end;">
            <div
              style="width: 260px;height: 480px;border: 1px solid #999999;margin-right: 20px;"
            >
              <div style="overflow: hidden;height: 100%">
                <img :src="bookHead" width="260px" alt="" />
                <div style="position:relative;width: 100%;height: 100%;">
                  <img
                    style="position: absolute;"
                    :src="form.background_pic"
                    width="260px"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div>
              <a-button type="link" @click="useDefaultFace('background')">
                使用默认图片
              </a-button>
              <a-upload
                accept=".png,.jpg,.jpeg"
                :action="upload_url"
                @change="uploadChanges"
                :data="{ remark: '自定义小程序背景图' }"
                :show-upload-list="false"
                :beforeUpload="beforeFaceUpload"
              >
                <div>
                  <a-button icon="cloud-upload"> 重新上传</a-button>
                  <span class="common-mute">
                    请上传宽高比为 750 : 1500px，并且小于1 MB的图片</span
                  >
                </div>
              </a-upload>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click="create">
            {{ form.id ? '更新规则' : '创建规则' }}
          </a-button>
          <a-button style="margin-left: 16px" @click="this.goBack">
            {{ form.id ? '放弃保存' : '取消创建' }}
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { get_sub } from '@/api'
import { program_list, modify_program, get_auto_rule } from '@/api/auto'
import store from '@/store'
import bookHead from '@/assets/book-headauto.png'

export default {
  name: 'PostModify',
  data() {
    let typeList = store.getters.autoDataList
    let upload_url = this.UPLOAD_URL

    return {
      upload_url,
      typeList,
      bookHead,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      programType: [
        { name: '预约类', value: 0 },
        { name: '查询类', value: 1 },
      ],
      categoryType: [],
      dataList: [],
      form: {
        id: undefined,
        name: undefined,
        category: undefined,
        table_id: undefined,
        head_pic: 'https://image.sdwx.zgkfpt.cn/155be8a/auto/auto_head_pic.png',
        background_pic:
          'https://image.sdwx.zgkfpt.cn/155be8a/book/fengmian.png',
      },
      rule: {
        name: [
          { required: true, message: '请输入小程序名称', trigger: 'blur' },
        ],
        category: [{ required: true, message: '请选择项目', trigger: 'blur' }],
        table_id: [
          { required: true, message: '请选择数据表', trigger: 'blur' },
        ],
        rule: [{ required: true, message: '请设置规则', trigger: 'blur' }],
      },
    }
  },
  created() {
    const { id } = this.$route.query
    if (!this.$HelperUtil.isEmpty(id)) {
      // 加载数据以供修改
      get_auto_rule({ id }).then((res) => {
        this.form.id = res.data.id
        this.form.name = res.data.name
        this.form.category = res.data.category
        this.dataList = [{ id: res.data.table_id, name: res.data.table_name }]
        this.form.table_id = res.data.table_id
        this.form.head_pic = res.data.head_pic
        this.form.background_pic = res.data.background_pic
      })
    }
    // 获取项目类型
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.categoryType = res.list
      }
    })
  },
  methods: {
    // 获取要查询的数据表表格
    getDataList(name = null) {
      program_list({
        category: this.form.category,
        name: name,
      }).then((res) => {
        if (res.code === 1) {
          this.dataList = res.list
        }
      })
    },
    dataChange(val) {
      if (!this.$HelperUtil.isEmpty(val)) {
        console.log(val)
        this.getDataList(val)
      }
    },
    uploadChange(e) {
      let status = e.file.status
      if (status === 'done') {
        this.form.head_pic = e.file.response.info.web_url
      }
    },
    uploadChanges(e) {
      let status = e.file.status
      if (status === 'done') {
        this.form.background_pic = e.file.response.info.web_url
      }
    },
    beforeFaceUpload(file) {
      //读取图片数据
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = (e) => {
          // //加载图片获取图片真实宽度和高度
          let image = new Image()
          image.onload = () => {
            let height = image.height
            let width = image.width
            console.log(height)
            console.log(width)
            if (height === 1500 && width === 750) {
              resolve(true)
            } else {
              this.$message.error('图片比例不正确')
              reject('比例错误')
            }
          }
          image.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },

    beforeHeadUpload(file) {
      //读取图片数据
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = (e) => {
          // //加载图片获取图片真实宽度和高度
          let image = new Image()
          image.onload = () => {
            let height = image.height
            let width = image.width
            if (height === 200 && width === 690) {
              resolve(true)
            } else {
              this.$message.error('图片比例不正确')
              reject('比例错误')
            }
          }
          image.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    useDefaultFace(type) {
      if (type === 'head') {
        this.form.head_pic =
          'https://image.sdwx.zgkfpt.cn/155be8a/auto/auto_head_pic.png'
      } else if (type === 'background') {
        this.form.background_pic =
          'https://image.sdwx.zgkfpt.cn/155be8a/book/fengmian.png'
      }
    },
    create() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          modify_program({
            id: this.form.id,
            name: this.form.name,
            category: this.form.category,
            table_id: this.form.table_id,
            head_pic: this.form.head_pic,
            background_pic: this.form.background_pic,
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg)
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.head-button {
  position: absolute;
  bottom: 80px;
  width: 140px;
  margin-left: 63px;
  line-height: 40px;
  border-radius: 45px;
  font-size: 16px;
  text-align: center;
  background: #fc3a51;
  color: #fff;
  cursor: pointer;
}

.head-message {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 10%;
}

.head-button-group {
  position: absolute;
  display: flex;
  top: 20%;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  flex-wrap: wrap;
}

.head-button-group span {
  width: 45%;
  margin: 0 6px 20px 6px;
  text-align: center;
  background: #f7f8f9;
  border-radius: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 700;
}

.icon-move {
  font-size: 18px;
  vertical-align: middle;
  margin-right: 8px;
  cursor: move;
}

.draggable {
  height: 312px;
  overflow-y: scroll;
}

.draggable-icon {
  font-size: 18px;
  vertical-align: middle;
  margin-right: 8px;
  cursor: move;
}

.draggable-remove {
  vertical-align: middle;
  cursor: pointer;
  margin-right: 8px;
}
</style>
